<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="foreword">
<p style="text-align: center;"><img alt="" src="media/file0.png" style="width:3.37912in;height:0.76042in"/></p>
<p style="text-align: center;"><strong>By John or “Jack” Shirley</strong></p><br/>
<p style="text-indent:0px;">I do not claim to be a sailor – a real sailor. I just happen to have been a young man who was of an age to be caught up in the last Great War. My memories are still there, so perhaps there is a point in putting them down, not as an exorcism, but in the hope that they may be of some interest to those who believe in the value of memories.</p><br/>
<div class="figure" style="text-align: center;">
<img alt="" src="media/file1.jpg" style="width:3.49444in;height:4.66064in"/>
<p class="caption">A person posing for the camera Description automatically generated</p>
</div>
<p style="text-align: center;"><strong>1938</strong></p>
<p style="text-align: center;"><strong>John Shirley foreground with his brother, Walter.</strong></p>
<p style="text-align: center;"><strong><br/>
</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?d725bdac